import { withInstall, withNoopInstall } from '@park-ui/utils'
import CigTable from './src/table.vue'
import columnPopover from './src/columnPopover.vue'

export const ElCigTable = withInstall(CigTable)
export const ElColumnPopover = withNoopInstall(columnPopover)
export default ElCigTable


export * from './src/popover'
export * from './src/table'